import React from "react";
import { $, merge } from "glamor";
import theme from "styles/theme";
import chunk from "lodash/chunk";

interface IProps {
    colDef: any;
    node: any;
    value: string[][] | string;
    valueFormatted: string;
}

const styles = merge(
    {},
    $(" .size", {
        background: theme.palette.lightGrey,
        borderRadius: "2px",
        padding: "2px 6px",
        fontWeight: "bold",
    }),
    $(" .quantity", {
        padding: "2px 6px",
    })
);

const renderInventorySizes = (sizes: string[][]) => {
    const itemsSize = sizes?.length;
    return sizes?.map(([size, quantity], index) => {
        const separator = index < itemsSize - 1 ? "," : "";
        return (
            <span key={size}>
                <span className="size">{size}</span>
                <span className="quantity">
                    {quantity}
                    {separator}
                </span>
            </span>
        );
    });
};

const InventoryUnitsRenderer: React.FC<IProps> = (props) => {
    const { node, colDef, value, valueFormatted } = props;

    let sizeNodes: string[][];
    let theValue = null;
    if (node.group && colDef.cellRenderer !== "agGroupCellRenderer") {
        if (node.aggData && colDef.aggFunc) {
            theValue = valueFormatted;
        }
    } else {
        if (colDef.cellRenderer === "agGroupCellRenderer") {
            sizeNodes = chunk(((value as string) || "").split(","), 2);
        } else {
            sizeNodes = value as string[][];
        }
    }

    if (!sizeNodes) {
        return theValue;
    }

    return <div {...styles}>{renderInventorySizes(sizeNodes)}</div>;
};

export { InventoryUnitsRenderer };
